export function isFetchBaseQueryError(error: any): error is { data: any; status: number; error?: string } {
  return error && typeof error.status === 'number';
}

export function isErrorWithMessage(error: any): error is { message: string } {
  return error && typeof error.message === 'string';
}

export function isServerErrorWithCode(error: any, code: number): boolean {
  return error && 
         error.status === 400 && 
         error.data && 
         error.data.Code === code;
}

export function clearAllSessionData(): void {
  const lastUsername = localStorage.getItem('lastUsername');
  
  sessionStorage.clear();
  localStorage.clear();
  
  if (lastUsername) {
    localStorage.setItem('lastUsername', lastUsername);
  }
} 